import React, { useCallback, useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TextField,
  MenuItem,
  ListItemText,
  InputAdornment,
  Radio,
  RadioGroup,
  FormControlLabel,
  Autocomplete,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import SettingsIcon from "@mui/icons-material/Settings";

import {
  listAccountMaster,
  listAccountMasterSearch,
  listBankDetails,
  listHSN,
  searchHSN,
  createBankDetails,
  createUserPreference,
} from "../../graphql";

import { API, graphqlOperation } from "aws-amplify";
import { createAccountGSTDetails } from "../../graphql/mutations";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IfscFetch } from "../../library/IfscFetch";
import ListOfAccountGroups from "../../library/ListOfAccountGroups";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import AddNewPartyModal from "../../pages/PrimeFigma/Modals/AddNewPartyModal";
import { useDebounce } from "../../hooks/useDebounce";
import { debounce } from "lodash";
import { AddBox } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import AddHSNModal from "../../pages/PrimeFigma/Modals/AddHSNModal";
import { useThemes } from "../Theme/theme";
import { CustomListAccountMasterSearch } from "../../graphql";
import {
  listAccountMasterv2Api,
  useCreateAccountMasterMutation,
} from "../../redux/apis/accountMaster.api";
import { useListGroupMasterQuery } from "../../redux/apis/accountGroupMaster.api";
import CreateGroup from "./CreateGroup";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  // minWidth: "90%",
  // '@media (min-width:600px)': {
  //   minWidth: '500px',
  // },
  // '@media (min-width:600px)': {
  //   width: 'auto',
  // },
  // minWidth: '500px',
  width: { xs: "90%", sm: "500px" },
};

const AccountTypes = [
  { option: "Current Account", value: "1" },
  { option: "Savings Account", value: "2" },
  { option: "Overdraft", value: "3" },
];

const CreateLedger = ({
  name,
  gstRate,
  disable,
  open,
  setOpen,
  groupName,
  padding,
  // defaultGroupID,
  selectedRow,
  setLedgerData,
  setNewLedgerResponse,
  setNeedDashBoardRender,
  setGstData,
  passFn,
  setNewId,
  setNewPartyID,
  head,
}) => {
  const { theme } = useThemes();
  const [defaultGroupId, setDefaultGroupID] = useState([]);
  let [options, setOptions] = useState([]);
  let randomNum = Math.floor(Math.random() * 100 + 1);
  let timeStamp = Math.floor(new Date().getTime() / 1000);
  let randomNumber = randomNum + timeStamp.toString().slice(3, 10);
  const [HSNCodes, SetHSNCOdes] = useState([]);
  const [filterHSN, setFilterHSN] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [iniHSN, setIniHSN] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [listOfBanks, setListOfBanks] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [newGroupVal, setNewGroupVal] = useState("");
  // const suggestions = [{label:"",id:1},{label:"abc",id:2}]
  const [suggestions, setsuggestions] = useState([]);
  const [newGroup, setNewgroup] = useState(false);
  const [newGroupModal, setNewGroupModal] = useState(false);

  const initialState = {
    group: "",
    name: "",
    gstrate: "",
    cessType: "Amount",
    cess: "",
    hsnCode: { label: "", value: "" },
    HSN: "",
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
    accountType: "",
    branch: "",
    SwiftCode: "",
    errorStatus: {
      group: false,
      name: false,
      gstrate: false,
      cessType: false,
      cess: false,
      hsnCode: false,
      bankName: false,
      bankAccountNo: false,
      ifscCode: false,
      accountType: false,
      branch: false,
      SwiftCode: false,
    },
    errorFields: {
      group: "",
      name: "",
      gstrate: "",
      cessType: "",
      cess: "",
      hsnCode: "",
      bankName: "",
      bankAccountNo: "",
      ifscCode: "",
      branch: "",
      accountType: "",
      SwiftCode: "",
    },
    edit: {
      name: false,
    },
  };
  const [state, setState] = useState(initialState);
  console.log(state.name,"===>state.name")

  const { data: allGroups, isLoading: circularOpen } =
    useListGroupMasterQuery();
  const rightSideValues = ["22", "24", "18"];

  useEffect(() => {
    if (state.HSN !== "") {
      setState((prev) => ({
        ...prev,
        hsnCode: {
          label: state.HSN.label,
          value: state.HSN.value,
        },
      }));
    }
  }, [state.HSN]);

  const [partyType, setPartyType] = useState("");
  const [openPartyModal, setOpenPartyModal] = useState(false);

  const handlePartyModal = (type) => {
    setOpenPartyModal(true);
    setPartyType(type);
    setBackdropOpen(false);
  };

  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  const registrationType =
    companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype;

  const BANK_GROUP_IDS = new Set(["17", "29"]);

  const { data: groupMaster, isLoading, isError } = useListGroupMasterQuery();

  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState("");

  const handleChange = (e, newValue) => {
    const name = e.target.name;
    const value = e.target.value;
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: false,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };

  const fetchLedgers = useCallback(
    useDebounce(async (value) => {
      try {
        let res = await API.graphql(
          graphqlOperation(CustomListAccountMasterSearch, {
            word: value.toLocaleLowerCase(),
          })
        );
        const filteredData = res.data.listAccountMasterSearch.filter((item) =>
          item.accountname.toLowerCase().includes(value.toLowerCase())
        );
        setsuggestions((prev) => [
          ...filteredData.map((elem) => {
            return {
              label: elem?.accountname + elem?.accountgroupname,
              ledger: elem?.accountname,
              group: elem?.accountgroupname,
            };
          }),
        ]);
      } catch (error) {
        console.log(error);
      }
    }, 500),
    []
  );

  useEffect(() => {
    if (open) {
      let groupData = groupMaster || [];
      let GSTArrayValues = [31, 32, 33];
      let setArrayAll =
        companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype !== 1
          ? [...groupData]
          : groupData.filter(
              (e) => !GSTArrayValues.includes(e?.accountgroupid)
            );
      setArrayAll?.sort((a, b) =>
        a.accountgroupname?.localeCompare(b?.accountgroupname)
      );
      setState((prev) => ({
        ...prev,
        name: name !== undefined ? name : "",
        group: groupName,
        gstrate: gstRate !== undefined ? gstRate : "",
      }));

      setDefaultGroupID(groupName ? groupName : defaultGroupId);

      if (setArrayAll) {
        setArrayAll?.map((obj) => {
          createKey(obj);
        });
      }
    }

    return () => {
      setOptions([]);
    };
  }, [open, groupMaster]);

  
  useEffect(() => {
    const controlAndS = (e) => {
  
      if (e.ctrlKey && e.key.toLowerCase() === "s" && !newGroup) {
        e.preventDefault();
        saveChanges()
      }
    };
  
    window.addEventListener('keydown', controlAndS);
  
    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, [state]);

  function createKey(obj) {
    const newOption = {
      name: obj?.accountgroupname,
      value: obj?.accountgroupid,
      DisplayOrderNumber: obj?.displayordernumber,
      AccountTypeCD: obj?.accounttypecd,
      path: obj?.path,
    };

    setOptions((prevOptions) => [...prevOptions, newOption]);
  }

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setDefaultGroupID([]);
      setState(initialState);
      setOpen(false);
    }
  };

  

  async function searchSAC(value, limit) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, {
          rowfrom: 0,
          limitno: limit !== undefined ? limit : 10000,
          word: value,
        })
      );

      if (res.data.searchHSN !== null) {
        let arr = [{ label: "", value: "" }];
        res.data.searchHSN?.map((item) => {
          arr.push({
            label: `${item.hsnsaccode} - ${item.description}`,
            value: `${item.hsnsaccode}`,
          });
        });
        arr = arr.filter((e) => e.label !== "");
        setFilterHSN(arr);
        return arr;
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handleSearch = useCallback(
    debounce((searchValue) => {
      searchSAC(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (
      open &&
      filterHSN.length == 0 &&
      companyDetails?.relatedcompanydetailsnew?.[0]?.RegistrationType !== 1
    )
      searchSAC("0", 10);
  }, [open, filterHSN]);
  async function getSAC() {
    const res = await API.graphql(
      graphqlOperation(listHSN, { RowFrom: 100, LimitNo: 100 })
    );

    if (res.data.listHSN !== null) {
      let arr = [{ label: "", value: "" }];
      res.data.listHSN.filter((ele) => {
        arr.push({
          label: `${ele.HSNSACCode} - ${ele.Description}`,
          value: `${ele.HSNSACCode}`,
        });
      });
      SetHSNCOdes(arr);
    }
  }
  async function listSelectedBanKDetails() {
    try {
      const res = await API.graphql(graphqlOperation(listBankDetails));
      if (res.data.listBankDetails.length > 0) {
        res.data.listBankDetails.map((ele) => {
          if (ele.ObjectType === "COMPANY") {
            setListOfBanks(ele);
          }
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listLedgerData() {
    try {
      const res = await API.graphql(graphqlOperation(listAccountMaster));
      setLedger(res.data.listAccountMaster);
    } catch (error) {
      console.log("error", error);
    }
  }
  // useEffect(() => {
  //   if (open) {
  //     listLedgerData();
  //     // getSAC();
  //     // listSelectedBanKDetails();
  //   }
  // }, [open]);



  const isNameDuplicate = (list, nameKey, inputName) =>
    list?.some(
      (item) =>
        item?.[nameKey]?.toLowerCase()?.trim() ===
        inputName?.toLowerCase()?.trim()
    );

  const normalizeString = (str) => str?.toLowerCase()?.trim() || "";

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };
    const numberRegex = /^\d+(\.\d{1,2})?$/;

    const isBankGroup =
      defaultGroupId?.includes("17") || defaultGroupId?.includes("29");

    const anyBankFieldProvided =
      (data["bankName"] && data["bankName"].trim() !== "") ||
      (data["bankAccountNo"] && data["bankAccountNo"].trim() !== "") ||
      (data["accountType"] && data["accountType"].trim() !== "") ||
      (data["ifscCode"] && data["ifscCode"].trim() !== "") ||
      (data["branch"] && data["branch"].trim() !== "");

    const shouldValidateBankFields = isBankGroup && anyBankFieldProvided;

    Object.keys(data)?.map((key) => {
      if (key === "name") {
        const normalizedName = normalizeString(state.name);
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Name is required";
          obj.errorStatus.name = true;
        } else {
          if (isNameDuplicate(suggestions, "ledger", normalizedName)) {
            isvalid = false;
            obj.errorFields.name = "Account Name already exists";
            obj.errorStatus.name = true;
          }

          if (
            isNameDuplicate(groupMaster, "accountgroupname", normalizedName)
          ) {
            isvalid = false;
            obj.errorFields.name = "This name already exists in the group";
            obj.errorStatus.name = true;
          }
        }
      }
      if (key === "group") {
        if (!newGroupVal) {
          if (data[key] == "" || data[key] == undefined) {
            isvalid = false;
            obj.errorFields.group = "Group is required";
            obj.errorStatus.group = true;
          } else {
            obj.errorFields.group = "";
            obj.errorStatus.group = false;
          }
        }
      }

      if (shouldValidateBankFields) {
        if (key === "bankName") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.bankName = "Bank Name is required";
            obj.errorStatus.bankName = true;
          } else {
            obj.errorFields.bankName = "";
            obj.errorStatus.bankName = false;
          }
        }

        if (key === "bankAccountNo") {
          const accountNo = data[key]?.trim();
          if (!accountNo || accountNo === "") {
            isvalid = false;
            obj.errorFields.bankAccountNo = "Bank Account Number is required";
            obj.errorStatus.bankAccountNo = true;
          } else {
            const accountNoRegex = /^[0-9]{9,18}$/;
            if (!accountNoRegex.test(accountNo)) {
              isvalid = false;
              obj.errorFields.bankAccountNo =
                "Invalid Bank Account Number. It must be 9 to 18 digits.";
              obj.errorStatus.bankAccountNo = true;
            } else if (/^0+$/.test(accountNo)) {
              isvalid = false;
              obj.errorFields.bankAccountNo =
                "Invalid Bank Account Number. It cannot be all zeros.";
              obj.errorStatus.bankAccountNo = true;
            } else {
              obj.errorFields.bankAccountNo = "";
              obj.errorStatus.bankAccountNo = false;
            }
          }
        }

        if (key === "accountType") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.accountType = "Bank Account Type is required";
            obj.errorStatus.accountType = true;
          } else {
            obj.errorFields.accountType = "";
            obj.errorStatus.accountType = false;
          }
        }

        if (key === "ifscCode") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.ifscCode = "IFSC Code is required";
            obj.errorStatus.ifscCode = true;
          } else {
            if (data[key].match("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
              obj.errorFields.ifscCode = "";
              obj.errorStatus.ifscCode = false;
            } else {
              isvalid = false;
              obj.errorFields.ifscCode = "Invalid IFSC";
              obj.errorStatus.ifscCode = true;
            }
          }
        }

        if (key === "branch") {
          if (!data[key] || data[key].trim() === "") {
            isvalid = false;
            obj.errorFields.branch = "Branch is required";
            obj.errorStatus.branch = true;
          } else {
            obj.errorFields.branch = "";
            obj.errorStatus.branch = false;
          }
        }
      } else {
        if (
          [
            "bankName",
            "bankAccountNo",
            "accountType",
            "ifscCode",
            "branch",
          ].includes(key)
        ) {
          obj.errorFields[key] = "";
          obj.errorStatus[key] = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }

  const dispatch = useDispatch();

  const [createAccountMaster] = useCreateAccountMasterMutation();

  async function addBankDetails(data) {
    try {
      const accountCreateRes = await createAccountMaster({
        createAccountMasterInput: {
          accountname: data.ledgeraccount,
          accountgroupid: newGroupVal ? newGroupVal : state.group,
          accounttypecd: "BS",
          hsnsaccode: 0,
        },
      });

      data.bankdetailsid = accountCreateRes?.data?.accountsid;

      const res = await API.graphql(
        graphqlOperation(createBankDetails, {
          createBankDetailsInput: data,
        })
      );
      if (listOfBanks.length === 0) {
        const userPreferenceData = {
          additionalvalue: "",
          attributetypecd: "SelectedBankDetails",
          attributevalue: data.bankdetailsid,
        };
        const resUserPreferenceData = await API.graphql(
          graphqlOperation(createUserPreference, {
            createUserPreferenceInput: userPreferenceData,
          })
        );
      }
      if (setNewLedgerResponse) {
        setNewLedgerResponse((prev) => [...prev, data.bankdetailsid]);
      }
      setNewId(data.bankdetailsid);
      showSuccessSnackbar("Ledger Created Successfully");
      setBackdropOpen(false);
      passFn();
      if (setNeedDashBoardRender) {
        setNeedDashBoardRender(true);
      }
    } catch (error) {
      console.log(error);
      setBackdropOpen(false);
    }
  }
  const [accountTypeCD, setAccountTypeCD] = useState("");
  async function saveChanges() {
    const {
      group,
      name,
      gstrate,
      cessType,
      cess,
      hsnCode,
      bankAccountNo,
      bankName,
      ifscCode,
      accountType,
      branch,
      // SwiftCode,
    } = state;
    const formData = {
      group,
      name,
      gstrate,
      cessType,
      cess,
      hsnCode,
      bankName,
      bankAccountNo,
      ifscCode,
      accountType,
      branch,
      // SwiftCode,
    };
    if (formValidation(formData)) {
      setBackdropOpen(true);
      const data = {
        accountname: state.name,
        accountgroupid: newGroupVal ? newGroupVal : state.group,
        accounttypecd:
          accountTypeCD === "" || accountTypeCD == undefined
            ? selectedRow?.relatedData?.AccountTypeCD
            : accountTypeCD,
        hsnsaccode: hsnCode.value == "" ? 0 : hsnCode.value,
      };
      const gstData = {
        accountid: randomNumber,
        effectivedate: Math.floor(new Date().getTime() / 1000),
        expireddate: 0,
        gstcompensationtype: cessType,
        gstrate: gstrate,
        hsnid: hsnCode.value == "" ? 0 : hsnCode.value,
        cessamount: cess == "" ? 0 : cess,
      };
      const bankDetails = {
        bankaccountnumber: state.bankAccountNo,
        bankname: state.bankName,
        branch: state.branch,
        ifsccode: state.ifscCode,
        notes: "",
        objectid: companyDetails?.companyid,
        objecttype: "COMPANY",
        ledgeraccount: state.name,
        bankaccounttype: state.accountType,
        cash: 0,
        swiftcode: state.SwiftCode,
        expiredtimestamp: 0,
        companybranchid: 0,
        upi: "",
      };

      if (defaultGroupId?.includes("17") || defaultGroupId?.includes("29")) {
        addBankDetails(bankDetails);
      } else {
        setGstData(gstData);
        setLedgerData(data);
      }

      setState(initialState);
      setBackdropOpen(false);
      setOpen(false);
      setDefaultGroupID("");
      setNewGroupVal("");
    }
  }

  const handleAutoGenerateLedgerName = (e) => {
    if (
      state?.edit?.name === false &&
      state?.bankName?.length &&
      state.branch?.length &&
      state.bankAccountNo?.length
    ) {
      const value =
        state.bankName +
        "" +
        state.branch.slice(0, 8) +
        "" +
        state.bankAccountNo.toString().slice(-4);

      fetchLedgers(value);
      setState((prev) => ({
        ...prev,
        name: value,
      }));
    }
  };

  return (
    <Box>
      {openPartyModal ? (
        <AddNewPartyModal
          open={openPartyModal}
          setOpen={(value) => {
            setOpenPartyModal(value);
            setOpen(value);
          }}
          newPartyName={state.name}
          Type={"Accounts"}
          partyType={
            partyType == "SUPPLIER"
              ? "supplier"
              : partyType == "CUSTOMER"
              ? "customer"
              : "Add Party"
          }
          passFn={passFn}
          setNewPartyID={setNewPartyID}
        />
      ) : null}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading || backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {head ? head : "Add Ledger"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: "5px", sm: "15px" },
                // height:{xs:"400px",sm:'auto'},
              }}
            >
              {defaultGroupId?.some((id) => BANK_GROUP_IDS?.has(id)) && (
                <>
                  <Box
                    sx={{
                      marginBottom: "20px",
                      padding: { xs: "10px 0px", sm: "10px 10px" },
                      borderRadius: "12px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                      ":hover": {
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                      },
                      transition: "all 1s ease-in-out",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.ifscCode == true ? true : false
                          }
                          label="IFSC Code"
                          name="ifscCode"
                          id="ifscCode"
                          fullWidth
                          value={state.ifscCode}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setState((prev) => ({
                              ...prev,
                              ifscCode: value,
                            }));
                            if (value === "") {
                              setState((prev) => ({
                                ...prev,
                                ifscCode: value,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ifscCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ifscCode: "IFSC Code is required",
                                },
                              }));
                            } else {
                              if (value.match("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
                                setBackdropOpen(true);
                                setState((prev) => ({
                                  ...prev,
                                  ifscCode: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ifscCode: false,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ifscCode: "",
                                  },
                                }));
                                IfscFetch(value)
                                  .then((e) => {
                                    setState((prev) => ({
                                      ...prev,
                                      bankName: e.data.bankName,
                                      branch: e.data.branchName,
                                      errorFields: {
                                        bankName: "",
                                        branch: "",
                                      },
                                      errorStatus: {
                                        bankName: false,
                                        branch: false,
                                      },
                                    }));
                                    setBackdropOpen(false);
                                  })
                                  .catch((e) => {
                                    showWarningSnackbar(
                                      "IFSC not found in our database"
                                    ); //need to test
                                    console.log("error", e);
                                    setBackdropOpen(false);
                                  });
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ifscCode: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ifscCode: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ifscCode: "Invalid IFSC",
                                  },
                                }));
                                setState((prev) => ({
                                  ...prev,
                                  bankName: "",
                                  branch: "",
                                }));
                              }
                            }
                          }}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.ifscCode}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.bankName === true ? true : false
                          }
                          name="bankName"
                          label="Bank Name"
                          id="BanK Name"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={state.bankName}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;

                            if (value != "addgstrate") {
                              if (value === "") {
                                setState((prev) => ({
                                  ...prev,
                                  ["bankName"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["bankName"]: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["bankName"]: "Bank Name is required",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ["bankName"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["bankName"]: false,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["bankName"]: "",
                                  },
                                }));
                              }
                            }
                          }}
                          sx={{
                            ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                              {
                                fontSize: "14px",
                              },
                            label: {
                              fontSize: "14px",
                            },
                            ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                              fontSize: "14px",
                            },
                            ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                            ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                              borderColor: "input.border",
                            },
                            ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        ></TextField>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.bankName}
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.branch == true ? true : false
                          }
                          label="Branch"
                          name="branch"
                          id="branch"
                          fullWidth
                          value={state.branch}
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => handleChange(e)}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.branch}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.bankAccountNo == true
                              ? true
                              : false
                          }
                          label="Bank Account Number"
                          name="bankAccountNo"
                          id="bankAccountNo"
                          fullWidth
                          onBlur={handleAutoGenerateLedgerName}
                          onChange={(e) => {
                            if (e.target.value == "") {
                              setState((prev) => ({
                                ...prev,
                                bankAccountNo: e.target.value,
                                errorFields: {
                                  bankAccountNo: "Bank Account No is required",
                                },
                                errorStatus: {
                                  bankAccountNo: true,
                                },
                              }));
                            } else {
                              if (
                                !new RegExp(/^^\d{9,34}$/).test(e.target.value)
                              ) {
                                setState((prev) => ({
                                  ...prev,
                                  bankAccountNo: e.target.value,
                                  errorFields: {
                                    bankAccountNo: "Invalid Bank Account No",
                                  },
                                  errorStatus: {
                                    bankAccountNo: true,
                                  },
                                }));
                              } else if (/^0+$/.test(e.target.value)) {
                                setState((prev) => ({
                                  ...prev,
                                  bankAccountNo: e.target.value,
                                  errorFields: {
                                    bankAccountNo:
                                      "Invalid Bank Account Number. It cannot be all zeros.",
                                  },
                                  errorStatus: {
                                    bankAccountNo: true,
                                  },
                                }));
                              } else if( !new RegExp(/^[0-9]{6,20}$/).test(
                                e.target.value
                              )){
                                setState((prev) => ({
                                  ...prev,
                                  bankAccountNo: e.target.value,
                                  errorFields: {
                                    bankAccountNo:
                                      "Invalid Bank Account No",
                                  },
                                  errorStatus: {
                                    bankAccountNo: true,
                                  },
                                }));
                              }
                              else {
                                setState((prev) => ({
                                  ...prev,
                                  bankAccountNo: e.target.value,
                                  errorFields: {
                                    bankAccountNo: "",
                                  },
                                  errorStatus: {
                                    bankAccountNo: false,
                                  },
                                }));
                              }
                            }
                          }}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.bankAccountNo}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { sm: "flex-start" },
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        flexDirection: { xs: "column", sm: "row" },
                        marginBottom: "0px",
                      }}
                    >
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.SwiftCode == true ? true : false
                          }
                          label="Swift Code"
                          name="SwiftCode"
                          id="SwiftCode"
                          fullWidth
                          value={state.SwiftCode}
                          onChange={(e) => handleChange(e)}
                          size="small"
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.SwiftCode}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.accountType == true ? true : false
                          }
                          select
                          label="Bank Account Type"
                          name="accountType"
                          id="accountType"
                          fullWidth
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;

                            if (value != "addgstrate") {
                              if (value === "") {
                                setState((prev) => ({
                                  ...prev,
                                  ["accountType"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["accountType"]: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["accountType"]:
                                      "Bank Account Type is required",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ["accountType"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["accountType"]: false,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["accountType"]: "",
                                  },
                                }));
                              }
                            }
                          }}
                          vakue={state.accountType}
                          size="small"
                          sx={{
                            "& .MuiSelect-select": {
                              fontSize: "0.80rem",
                            },
                            "& .css-1rtm8vu-MuiTypography-root": {
                              fontSize: "0.80rem",
                            },
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        >
                          {AccountTypes.map((item, ind) => {
                            return (
                              <MenuItem
                                key={item.value}
                                value={`${item.value}`}
                              >
                                <ListItemText
                                  sx={{ margin: "0px" }}
                                  primary={item.option}
                                />
                              </MenuItem>
                            );
                          })}
                        </TextField>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.accountType}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}

              <Box sx={{ display: "flex" }}>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <Autocomplete
                    id="autocomplete"
                    options={suggestions}
                    autoHighlight
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        display: "none", // Hide the dropdown icon
                      },
                    }}
                    size="small"
                    // getOptionLabel={(option) => option?.label}
                    // defaultValue={suggestions[0]}
                    value={state.name}
                    onChange={(e, newValue) => {
                      if (e.target.value == undefined) {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          edit: { ...prev.edit, name: true },
                          errorFields: {
                            ...prev.errorFields,
                            name: "Account Name is required",
                          },
                          errorStatus: { ...prev.errorStatus, name: true },
                        }));
                      }
                    }}
                    classes={{
                      popper: "customPopperAutoCmpt",
                      paper: "customPaperAutoCmpt",
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        onClick={(e) => e.preventDefault()}
                        disabled
                      >
                        <b>
                          {" "}
                          {option?.ledger ?? (
                            <Typography
                              component={"span"}
                              sx={{ color: "error.main" }}
                            >
                              No Ledger
                            </Typography>
                          )}
                        </b>{" "}
                        <i>({option?.group})</i>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="name"
                        required
                        onChange={(e) => {
                          const trimmedValue = e?.target?.value?.trim();
                          if (trimmedValue === "") {
                            setState((prev) => ({
                              ...prev,
                              name: trimmedValue,
                              edit: { ...prev.edit, name: true },
                              errorFields: {
                                ...prev.errorFields,
                                name: "Account Name is required",
                              },
                              errorStatus: { ...prev.errorStatus, name: true },
                            }));
                          } else {
                            fetchLedgers(trimmedValue);
                            let isvalid = true;

                            ledger.forEach((item) => {
                              if (
                                item.AccountName.toLowerCase() ===
                                trimmedValue.toLowerCase()
                              ) {
                                isvalid = false;
                              }
                            });

                            if (!isvalid) {
                              setState((prev) => ({
                                ...prev,
                                name: trimmedValue,
                                errorFields: {
                                  ...prev.errorFields,
                                  name: "Account Name already exists",
                                },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  name: true,
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                name: trimmedValue,
                                errorFields: { ...prev.errorFields, name: "" },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  name: false,
                                },
                              }));
                            }
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > 100) {
                            e.target.value = e.target.value.slice(0, 100);
                          }
                        }}
                        label="New Ledger Name"
                        variant="outlined"
                        onBlur={() => {
                          const trimmedName = state.name?.trim();
                          if (
                            suggestions.some(
                              (elem) =>
                                elem.label?.toLowerCase() ==
                                trimmedName?.toLowerCase()
                            )
                          ) {
                            setState((prev) => ({
                              ...prev,
                              name: prev.name?.replace(/\s+/g, " ")?.trim(),
                              errorStatus: { ...prev.errorStatus, name: true },
                              errorFields: {
                                ...prev.errorFields,
                                name: "Account Name Required",
                              },
                            }));
                          }
                        }}
                        error={state.errorStatus.name}
                        sx={{
                          "& .MuiInputBase-root": { fontSize: "14px" },
                          "& .MuiInputLabel-root": {
                            fontSize: "14px",
                            color: "input.font",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          "& .MuiFormLabel-root.Mui-focused": {
                            color: "input.font",
                          },
                          ".MuiInputLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                      />
                    )}
                    PaperComponent={(props) => {
                      if (state?.name?.length > 2 && suggestions.length > 0) {
                        return (
                          <Paper {...props}>
                            <Typography
                              style={{
                                padding: "4px",
                                paddingLeft: "6px",
                                color: "red",
                              }}
                              component="div"
                            >
                              Existing Ledgers
                            </Typography>
                            {props.children}
                          </Paper>
                        );
                      }
                    }}
                  />

                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.name}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <Autocomplete
                    disabled={disable == "group"}
                    disablePortal
                    autoHighlight
                    openOnFocus
                    key={options.length}
                    options={options}
                    getOptionLabel={(option) => option?.name}
                    value={(() => {
                      return (
                        options.find(
                          (option) =>
                            option?.value === newGroupVal ||
                            option?.value === state.group
                        ) || null
                      );
                      // return options.find((option) => option?.value ===state.group) || null;
                    })()}
                    classes={{
                      popper: "csmPopover",
                      listbox: "csmListBox",
                    }}
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          position: "relative",
                          "& .MuiAutocomplete-listbox": {
                            maxHeight: "200px",
                            overflowY: "auto",
                          },
                        }}
                      >
                        {props.children}
                        <Box
                          sx={{
                            position: "sticky",
                            bottom: 0,
                            background: "white",
                            boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
                            padding: "8px",
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "20px",
                            // textAlign: "center",
                            cursor: "pointer",
                          }}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                            setNewgroup(true);
                            setNewGroupModal(true);
                          }}
                        >
                          <AddBox
                            fontSize="small"
                            sx={{
                              marginRight: "5px",
                              color: "primary.main",
                            }}
                          />
                          <ListItemText
                            sx={{ color: "primary.main" }}
                            primary={"Add Group"}
                          />
                        </Box>
                      </Paper>
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const segments = newValue.path.split("/");
                        setAccountTypeCD(newValue?.AccountTypeCD);
                        if (segments.includes("15") || segments.includes("7")) {
                          handlePartyModal(
                            newValue.value === 7 ? "SUPPLIER" : "CUSTOMER"
                          );
                        }
                        setDefaultGroupID(segments);
                      } else {
                        setAccountTypeCD(null);
                        setDefaultGroupID(null);
                      }
                      let Event = {
                        target: { name: "group", value: newValue?.value },
                      };

                      handleChange(Event);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={state.errorStatus.group}
                        required={true}
                        label="Under Group"
                        variant="outlined"
                        size="small"
                        fullWidth
                        // InputLabelProps={{ shrink: true }}
                        sx={{
                          ".MuiInputBase-root": {
                            fontSize: "14px",
                          },
                          ".MuiInputLabel-root": {
                            fontSize: "14px",
                            color: "input.font",
                          },
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".MuiInputLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                      />
                    )}
                    noOptionsText="Not available"
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.group}
                  </Typography>
                </Box>
              </Box>

              {!defaultGroupId?.some((id) => BANK_GROUP_IDS?.has(id)) &&
              registrationType !== 1 &&
              rightSideValues?.some((value) =>
                defaultGroupId?.includes(value)
              ) ? (
                <Accordion sx={{ margin: 1 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ maxHeight: "auto" }}
                  >
                    <Typography
                      sx={{ color: "primary.main", fontWeight: "500" }}
                    >
                      GST Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          flex: { xs: 1, sm: 0.5 },
                          m: 1,
                          minWidth: "10px",
                        }}
                      >
                        <Autocomplete
                          openOnFocus
                          error={
                            state.errorStatus.hsnCode === true ? true : false
                          }
                          disablePortal
                          autoHighlight
                          id="HSN CODE"
                          name="hsnCode"
                          placeholder="HSN Code"
                          disableClearable
                          options={["Add HSN Code", ...filterHSN]}
                          isOptionEqualToValue={(option, value) =>
                            option.value == value.value
                          }
                          renderOption={(props, option) => (
                            <>
                              {option === "Add HSN Code" ? (
                                <MenuItem
                                  value={"addHsn"}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    setOpenHsnModal(true);
                                    setHSNParamsID("");
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    position: "sticky",
                                    top: "-8px",
                                    backgroundColor: grey[50],
                                    "&:hover": {
                                      backgroundColor: grey[200],
                                    },
                                  }}
                                >
                                  <AddBox
                                    fontSize="small"
                                    sx={{
                                      marginRight: "5px",
                                      color: "primary.main",
                                    }}
                                  />
                                  <ListItemText
                                    sx={{ color: "primary.main" }}
                                    primary={"Add HSN Code"}
                                  />
                                </MenuItem>
                              ) : (
                                <li {...props}>{option.label}</li>
                              )}
                            </>
                          )}
                          value={state.hsnCode}
                          onChange={(e, newValue) => {
                            if (newValue == "") {
                              setState((prev) => ({
                                ...prev,
                                hsnCode: newValue,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  hsnCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  hsnCode: "HSN Code is required",
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                hsnCode: newValue,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  hsnCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  hsnCode: "",
                                },
                              }));
                            }
                          }}
                          sx={{
                            ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingBottom: "5px",
                              },
                            ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingTop: "6px",
                                paddingBottom: "5px",
                                paddingLeft: "6px",
                              },
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              onChange={(event) => {
                                handleSearch(event.target.value);
                              }}
                              sx={{
                                ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    padding: "8.5px 7px",
                                  },
                                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                  {
                                    fontSize: "14px",
                                  },
                                label: {
                                  fontSize: "14px",
                                },
                                ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                  {
                                    fontSize: "14px",
                                  },
                                ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "input.border",
                                  },
                                ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                ".css-14qz1ij-MuiListItemText-root": {
                                  margin: "0px",
                                },
                                ".css-wgai2y-MuiFormLabel-asterisk": {
                                  color: "danger.main",
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="HSN Code"
                            />
                          )}
                        />
                        {searchValue < 3 &&
                        state.errorStatus.hsnCode !== true ? (
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "primary.main",
                            }}
                          >
                            Use atleast 3 characters
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.hsnCode}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <Autocomplete
                          openOnFocus
                          autoHighlight
                          options={[
                            { id: 0, rate: "0%" },
                            { id: 5, rate: "5%" },
                            { id: 12, rate: "12%" },
                            { id: 18, rate: "18%" },
                            { id: 28, rate: "28%" },
                          ]}
                          getOptionLabel={(option) => option.rate}
                          value={
                            [
                              { id: 0, rate: "0%" },
                              { id: 5, rate: "5%" },
                              { id: 12, rate: "12%" },
                              { id: 18, rate: "18%" },
                              { id: 28, rate: "28%" },
                            ].find((rate) => rate.id === state.gstrate) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setState((prev) => ({
                                ...prev,
                                gstrate: newValue.id,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  gstrate: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  gstrate: "",
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                gstrate: "",
                                errorStatus: {
                                  ...prev.errorStatus,
                                  gstrate: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  gstrate: "GST Rate is required",
                                },
                              }));
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={state.errorStatus.gstrate}
                              label="GST Rate"
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              helperText={
                                state.errorStatus.gstrate
                                  ? state.errorFields.gstrate
                                  : ""
                              }
                              sx={{
                                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                  {
                                    fontSize: "14px",
                                  },
                                label: {
                                  fontSize: "14px",
                                },
                                ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                  {
                                    fontSize: "14px",
                                  },
                                ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "input.border",
                                  },
                                ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                ".css-wgai2y-MuiFormLabel-asterisk": {
                                  color: "danger.main",
                                },
                              }}
                            />
                          )}
                          renderOption={(props, option) => (
                            <li {...props}>{option.rate}</li>
                          )}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.gstrate}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <Box
                          sx={{
                            position: "relative",
                            border: "solid 1px",
                            borderColor:
                              state.errorStatus.cessType === true
                                ? "danger.main"
                                : "input.border",
                            borderRadius: "4px",
                            padding: "10px 14px",
                            ".css-ahj2mt-MuiTypography-root": {
                              fontSize: "12px",
                              color: "input.font",
                            },
                            ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                              padding: "0px",
                              margin: "0px 5px",
                            },
                            ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                              padding: "0px",
                              margin: "0px 5px",
                              color: "input.border",
                            },
                            ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked":
                              {
                                color: "primary.main",
                              },
                            "&:focus-within": {
                              backgroundColor: "#ffb74d", // Background when focused
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.75em",
                              letterSpacing: "0.00938em",
                              position: "absolute",
                              top: "-10px",
                              left: "9px",
                              background: theme?.palette?.TmId.id
                                .toString()
                                .includes("9")
                                ? "#1E1E1E"
                                : "#fff",
                              padding: "0px 3px",
                              color:
                                state.errorStatus.cessType === true
                                  ? "danger.main"
                                  : "input.font",
                            }}
                          >
                            GST compensation Cess Type{" "}
                            <span style={{ color: "#e55353" }}>*</span>
                          </Typography>

                          <RadioGroup
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                event.preventDefault();
                                setState((prev) => ({
                                  ...prev,
                                  cessType:
                                    state.cessType == "Percentage"
                                      ? "Amount"
                                      : "Percentage",
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    cessType: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    cessType: "",
                                  },
                                }));
                              }
                            }}
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "row", sm: "row" },
                            }}
                            name="cessType"
                            value={state.cessType}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setState((prev) => ({
                                  ...prev,
                                  cessType: value,

                                  errorStatus: {
                                    ...prev.errorStatus,
                                    cessType: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    cessType:
                                      "Please Select GST Compensation  Type",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  cessType: value,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    cessType: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    cessType: "",
                                  },
                                }));
                              }
                            }}
                          >
                            <FormControlLabel
                              value="Percentage"
                              control={<Radio size="small" />}
                              label="Percentage"
                            />
                            <FormControlLabel
                              value="Amount"
                              control={<Radio size="small" />}
                              label="Amount"
                            />
                          </RadioGroup>
                        </Box>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state.errorFields.cessType}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={state.errorStatus.cess == true ? true : false}
                          label="Cess"
                          name="cess"
                          id="Cess"
                          fullWidth
                          onChange={(e) => handleChange(e)}
                          size="small"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {state.cessType == "Percentage" ? "%" : "₹"}
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.cess}
                        </Typography>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <></>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                disableRipple={false}
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <Button
                disableRipple={false}
                onClick={saveChanges}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Save
              </Button>
            </Box>
            {openHsnModal === true && (
              <AddHSNModal
                open={openHsnModal}
                setOpen={setOpenHsnModal}
                setData={setState}
                data={state}
                setFilterHSN={setFilterHSN}
                filteredHSN={filterHSN}
                searchHSNSAC={(value) => searchSAC(value)}
                hsnParamsID={hsnParamsID}
                page={"Invoice"}
              />
            )}
          </Paper>
        </Fade>
      </Modal>

      {newGroup && (
        <CreateGroup
          open={newGroupModal}
          setOpen={setNewgroup}
          groups={allGroups}
          setNewGroupVal={setNewGroupVal}
          setDefaultGroupID={setDefaultGroupID}
        />
      )}
    </Box>
  );
};

export default CreateLedger;
